export const getTotalSize = (selectedFiles) => selectedFiles.reduce((sum, file) => sum + file.size, 0);
